import { useState } from "react";
import { Overlay } from "react-bootstrap";
import FlexibleTooltip from "components/Overlay/FlexibleTooltip";
import Icon from "components/Icon/Icon";
import Lang from "components/Lang";

const ClipboardCopy = ({ value, tooltip = "top-end", className = "" }) => {
  if (value == null) {
    return null;
  }
  if (!window.navigator.clipboard) {
    return null;
  }
  const [copied, setCopied] = useState(false);
  const [tooltipTarget, setTooltipTarget] = useState(null);
  const [tooltipVisible, setTooltipVisible] = useState(false);
  const copy = () => {
    if (copied) {
      return;
    }
    navigator.clipboard.writeText(value).then(() => {
      setCopied(true);
    });
  };
  const handleHover = (event) => {
    setTooltipTarget(event.target);
    setCopied(false);
    setTooltipVisible(true);
  };
  const handleBlur = () => {
    setTooltipVisible(false);
  };
  return (
    <>
      <Icon
        role="button"
        className={className}
        icon="clipboard"
        onClick={copy}
        onMouseEnter={handleHover}
        onMouseLeave={handleBlur}
      />
      {Boolean(tooltip) && Boolean(tooltipVisible) && (<Overlay
        show={true}
        target={tooltipTarget}
        placement={tooltip}
      >

        <FlexibleTooltip>{copied ? <Lang>コピーしました</Lang> : <Lang>クリップボードにコピー</Lang>}</FlexibleTooltip>
      </Overlay>)}
    </>
  );
};

export default ClipboardCopy;